import ChicagoSection from "./ChicagoSection";
import HeroSection from "./HeroSection";
import SpecialsSection from "./SpecialsSection";
import TestimonialsSection from "./TestimonialsSection";

const Main = () => {
  return (
    <main>
      <HeroSection />
      <SpecialsSection />
      <TestimonialsSection />
      <ChicagoSection />
    </main>
  );
};

export default Main;
